export default "__VITE_ASSET__D2dLa7Q4__"